import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import { Skeleton } from "antd";
import { homeSelector } from "redux/selectors/homeSelector";
import ProgramCards from "./Cards";
import { sponsorDashboardSelector } from "redux/selectors/sponsorDashboard";
import {getSponsorsDashboard} from "redux/actions/dashboard-sponsors-actions";
import ThreeGeneral from "images/3DCASE.webp"
import { INTERNAL_LINKS } from "enum";

function CallForFacultyCards({ userProfile, getSponsorsDashboard, sponsorDasboardAcces }) {
    const [isFetching,setIsFetching] = useState(true)
    
    useEffect(() => {
        getSponsorsDashboard({},() => {setIsFetching(false)});
    },[])

    return (
        <div>
        <div style={{ padding: "1rem 0"}}>
            {isFetching ? (
                <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
                    {Array.from({ length: 3}).fill(1).map((_, i) => (<Skeleton width={268} height={500} />))}
                </div>
            ) : (
                <div className='container-list-certificates' style={{padding:'20px'}}>
                    {(sponsorDasboardAcces || []).map(program => {
                        return (<ProgramCards program={{
                            title: program?.partnersName,
                            link: `${INTERNAL_LINKS.SPONSORS_DASHBOARD_LIST}/${program?.uniqueLink}`,
                            image: 'without',
                        }} />)
                    })}
                </div>
            )}
        </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    ...sponsorDashboardSelector(state),
    ...homeSelector(state),
});

const mapDispatchToProps = {
    getSponsorsDashboard,
};

export default connect(mapStateToProps, mapDispatchToProps)(CallForFacultyCards);